var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("button", { staticClass: "scrollBtn", on: { click: _vm.scroll } }, [
    _c(
      "svg",
      {
        attrs: {
          width: "18px",
          height: "11px",
          viewBox: "0 0 18 11",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink"
        }
      },
      [
        _c("title", [_vm._v("Path 2")]),
        _vm._v(" "),
        _c("desc", [_vm._v("Created with Sketch.")]),
        _vm._v(" "),
        _c(
          "g",
          {
            attrs: {
              id: "Symbols",
              stroke: "none",
              "stroke-width": "1",
              fill: "none",
              "fill-rule": "evenodd"
            }
          },
          [
            _c(
              "g",
              {
                attrs: {
                  id: "Module/FooterStroke",
                  transform: "translate(-1364.000000, -139.000000)",
                  stroke: "#FFFFFF",
                  "stroke-width": "2"
                }
              },
              [
                _c("polyline", {
                  attrs: {
                    id: "Path-2",
                    transform:
                      "translate(1373.000000, 145.000000) rotate(-180.000000) translate(-1373.000000, -145.000000) ",
                    points: "1365 141.00936 1372.99532 149 1381 141"
                  }
                })
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }